<template>
  <FormCard>
    <template #header>
      <div class="card-header">
        <div>
          <div class="card-header__title">전달</div>
        </div>
      </div>
    </template>

    <div class="form-field">
      <label class="form-field__label">
        학교 선택 (USER) <span class="form-field__required">(필수)</span>
      </label>
      <div class="form-field__control" style="max-width: 320px">
        <v-autocomplete
          v-model="searchschool"
          :items="searchlist"
          no-data-text="결과를 찾을 수 없습니다."
          placeholder="학교를 검색해주세요."
          auto-select-first
          append-inner-icon="mdi-magnify"
          item-props
          density="compact"
          menu-icon=""
          variant="outlined"
          color="primary"
          hide-details
          spellcheck="false"
          @keyup.enter="schoolsearch()"
        />
      </div>
      <p class="form-field__helper">학교명 또는 코드(영문/숫자)로 검색</p>
    </div>

    <div class="contact-table-wrap">
      <ContactTable
        :code="schoolCode"
        :name="searchschool"
        :contact_info="contactInfo"
      />
    </div>
  </FormCard>
</template>

<script setup>
import { ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
import ContactTable from "./ContactTableComponent.vue";
import FormCard from "@/components/ui/FormCard.vue";

const store = useStore();

const searchdata = ref("");
const schoolCode = ref("");
const searchschool = ref(null);
const searchlist = ref([]);

const contactInfo = ref([]);

const schoolsearch = async () => {
  if (searchdata.value[searchschool.value]) {
    let regex = /^[a-zA-Z0-9]*$/;
    if (regex.test(searchschool.value)) {
      schoolCode.value = searchschool.value;
      searchschool.value = searchdata.value[searchschool.value];
    } else {
      const foundKey = Object.keys(searchdata.value).find(
        (key) => key === searchschool.value
      );
      schoolCode.value = searchdata.value[foundKey];
    }

    if (!schoolCode.value) {
      alert("학교 코드를 찾을 수 없습니다. 검색 목록 데이터를 확인해 주세요.");
      return;
    }
    alert(
      `학교 이름 : ${searchschool.value}\n학교 코드 : ${schoolCode.value}\n설정되었습니다.`
    );

    const contact = await store.dispatch("GET_SCHOOL_CONTACT", schoolCode.value);

    contactInfo.value = contact;
    store.commit("SET_MESSAGE_SEND_LIST_VIEW", true);
  } else {
    searchschool.value = "";
    schoolCode.value = "";
    alert("학교 정보가 존재하지 않습니다.");
  }
};

onBeforeMount(async () => {
  try {
    const res = await store.dispatch("GET_SEARCH_LIST");
    searchdata.value = res;
    searchlist.value = Object.getOwnPropertyNames(res);
  } catch (err) {
    console.log(err);
  }
});
</script>

<style scoped>
.card-header__title {
  font-size: var(--font-h3-size);
  line-height: var(--font-h3-line);
  font-weight: var(--font-h3-weight);
  color: var(--text-primary);
}

.card-header__desc {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.form-field__label {
  display: block;
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  line-height: var(--font-body-strong-line);
  color: var(--text-primary);
  margin-bottom: var(--space-2);
}

.form-field__required {
  margin-left: var(--space-1);
  font-size: var(--font-caption-size);
  font-weight: 400;
  color: #B42318;
}

.form-field__helper {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.contact-table-wrap {
  margin-top: calc(var(--space-5) / 2);
}
</style>
